/*
Code for the About Page
*/
import { Footer } from "./Footer";
import { Header } from "./Header";
import team from "./images/full_team.jpg";
import background from "./images/team_extended.png";
export const About = () => {
  return (
    <div>
      <Header />
      <div className="page-header">
        <img className="header-img" src={background} alt="background" />
        <h1 className="header-img-caption">About</h1>
        <p className="header-img-text">Learn how this website was made</p>
      </div>
      <div>
        <div className="space2"></div>
        <h2>About this Site</h2>
        <p className="about_text">
          This website was created by a team of nine 5C students. We saw that
          there was a need for a centralized, easily navigable resources hub for
          Scripps' Data Science Department. And beyond Scripps, we aim to serve
          data science students from across the 5Cs, as well as any individuals
          interested in related STEM fields.
        </p>

        <p className="about_text">
          This website was made by students, with the support of Scripps' DS
          faculty. However, it is first and foremost a
          student created and managed site, and the final authority on courses
          and all other related matters is the official Scripps Data Science
          webpage. Because this website is student created and supported,
           Scripps College’s Office of Marketing and Communications is not responsible 
           for the contents or maintenance of this website. If you are experiencing any issues with the site, please contact <a
          href="mailto:nkerschn7202@scrippscollege.edu"
          className="faculty-link"
        >
          nkerschn7202@scrippscollege.edu
        </a>
        .
        </p>
        <h2>Meet the Team</h2>

        <div className="team">
          <div className="team-list">
            <h3 className="team_title">Project Managers</h3>
            <ul>
              <li>Jay Renaker (SC '25)</li>
              <li>Nicole Kerschner (SC '26)</li>
            </ul>
            <h3 className="team_title">
              User Experience/User Interface Development
            </h3>
            <ul>
              <li>Acquah Yaw Danquah (PZ '28)</li>
              <li>Ceci Wade (PO '25)</li>
              <li>Diya Gangwar (HMC '26)</li>
              <li>Elizabeth Ortega (PO '27)</li>
            </ul>
            <h3 className="team_title">Software Engineering</h3>
            <ul>
              <li>Hanna Kenyatta (HMC '27)</li>
              <li>Sofia Robertson (HMC '27)</li>
              <li>Ambika Tiwari (SC '25)</li>
            </ul>
          </div>
          <img
            className="team-photo"
            src={team}
            alt="Data Science Website Team members"
            style={{ borderRadius: "8px" }}
          />
        </div>
      </div>
      <div className="space1" />
      <h2>Shoutouts and Special Thanks</h2>
      <p className="about_text">
        This project, as so many things in life, was made possible through the
        support of and collaboration with many other organizations and
        individuals. We are very grateful to everyone who contributed their
        time, feedback, and support to our efforts.
      </p>
      <p className="about_text">Special thanks to...</p>
      <div className="team">
        <ul>
          <li>
            The DS Faultly, Winston Ou, Michael Spezio, and Christina Edholm,
            for your support and belief in this project.
          </li>
          <li>
            P-ai Club, for providing the supporting structure for assembling
            this website's team, and sponsoring our snack runs.
          </li>
          <li>
            The Hive, for funding us via their Creativity Grant and allowing us
            to use their spaces. Shout out to the Hive's Intro to Human Centered
            Design class and faculty for for providing foundational knowledge of
            the need for human centered design.
          </li>
        </ul>
      </div>

      <h2>Contact</h2>
      <p className="about_text">
        Please see the faculty page if you'd like to contact a Data Science
        professor.
      </p>
      <p className="about_text">
        If you have questions about this website, please contact Nicole
        Kerschner (
        <a
          href="mailto:nkerschn7202@scrippscollege.edu"
          className="faculty-link"
        >
          nkerschn7202@scrippscollege.edu
        </a>
        ) or Jay Renaker (
        <a
          href="mailto:jrenaker2335@scrippscollege.edu"
          className="faculty-link"
        >
          jrenaker2335@scrippscollege.edu
        </a>
        ).
      </p>

      <div className="space1" />
      <Footer />
    </div>
  );
};
